$(document).ready(function () {
  $('.fcvp-owl').each(function () {
    var $owl = $(this);
    var sectionId = $owl.closest('.fc-variety-packks-slider').attr('id');

    $owl.owlCarousel({
      loop: true,
      margin: 20,
      dots: false,
      nav: true,
      navText: [
        '<svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.49155e-06 28.5C3.86759e-06 12.7599 12.7599 1.1155e-06 28.5 2.49155e-06C44.2401 3.86759e-06 57 12.7599 57 28.5C57 44.2401 44.2401 57 28.5 57C12.7599 57 1.1155e-06 44.2401 2.49155e-06 28.5Z" fill="#F0F0F0"/><path d="M28.5 38L34 38L28.5 28L34 18L28.5 18L23.5 28L28.5 38Z" fill="black"/></svg>',
        '<svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M57 28.5C57 44.2401 44.2401 57 28.5 57C12.7599 57 0 44.2401 0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5Z" fill="#F0F0F0"/><path d="M28.5 19H23L28.5 29L23 39H28.5L33.5 29L28.5 19Z" fill="black"/></svg>',
      ],
      navContainer: '#' + sectionId + ' .fcvp-nav',
      responsive: {
        0: {
          items: 1,
          stagePadding: 0,
        },
        768: {
          items: 2,
          stagePadding: 60,
        },
        1200: {
          items: 2,
          stagePadding: 140,
        },
      },
    });
  });
});
